<template>
<div class="LivePoster">
    <img :src="posterUrl" alt="">
</div>
</template>

<script>
import {getLivePoster} from 'api/mLiveApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'LivePoster',
    data() {
        return {
            posterUrl: ''
        }
    },
    mounted() {
        this.findLivePoster()
    },
    methods: {
        findLivePoster() {
            this.setLoading(true)
            var params = {
                innerid: this.$route.query.liveid
            }
            getLivePoster({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.posterUrl = data.data.eventposteratturl
                },
                error: data => {
                    // console.log('error：', data)
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.LivePoster {
    &>img {
        width: 100vw;
    }
}
</style>